import { httpClient } from './core';

export interface LegacyFachMappingDto {
  id: number;
  source_system: string;
  legacy_id: number;
  new_fach_id: number;
  new_fach_name: string | null;
}

export interface FachOption {
  id: number;
  name: string;
  aktiv: boolean;
}

export interface LegacyFachMappingsResponse {
  mappings: LegacyFachMappingDto[];
  faecher: FachOption[];
}

export interface UpsertMappingPayload {
  legacy_fach_id: number;
  new_fach_id: number;
}

export interface BulkMappingPayload {
  mappings: UpsertMappingPayload[];
}

export interface BulkMappingResult {
  written: number;
  skipped: number;
  errors: Array<{ index: number; reason: string; new_fach_id?: number }>;
}

export const legacyFachMappingApi = {
  list: async (): Promise<LegacyFachMappingsResponse> => {
    const res = await httpClient<LegacyFachMappingsResponse>(`/api/admin/legacy-fach-mappings`);
    if (res.error || !res.data) throw new Error(res.error || 'Mappings konnten nicht geladen werden');
    return res.data;
  },
  upsert: async (payload: UpsertMappingPayload): Promise<void> => {
    const res = await httpClient<{ ok: boolean }>(`/api/admin/legacy-fach-mappings`, {
      method: 'POST',
      body: JSON.stringify(payload),
    } as RequestInit);
    if (res.error) throw new Error(res.error);
  },
  delete: async (legacyFachId: number): Promise<void> => {
    const res = await httpClient<{ ok: boolean }>(`/api/admin/legacy-fach-mappings`, {
      method: 'DELETE',
      body: JSON.stringify({ legacy_fach_id: legacyFachId }),
    } as RequestInit);
    if (res.error) throw new Error(res.error);
  },
  bulk: async (payload: BulkMappingPayload): Promise<BulkMappingResult> => {
    const res = await httpClient<BulkMappingResult>(`/api/admin/legacy-fach-mappings/bulk`, {
      method: 'POST',
      body: JSON.stringify(payload),
    } as RequestInit);
    if (res.error || !res.data) throw new Error(res.error || 'Bulk-Update fehlgeschlagen');
    return res.data;
  },
};
